module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec07_sp_207776c5be5cdb3955a24fbd74004402.jpg";